import { render } from "./AdminOrders.vue?vue&type=template&id=b9c47a62&scoped=true"
import script from "./AdminOrders.vue?vue&type=script&lang=js"
export * from "./AdminOrders.vue?vue&type=script&lang=js"

import "./AdminOrders.vue?vue&type=style&index=0&id=b9c47a62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c47a62"]])

export default __exports__